import { modifier } from 'ember-modifier';

/**
 * @param {Event} e
 */
const preventDefault = (e) => {
  e.preventDefault();
};

/**
 *
 */
export default modifier((element, [event]) => {
  element.addEventListener(event, preventDefault);

  return () => {
    element.removeEventListener(event, preventDefault);
  };
}, { eager: false });
